// cookie manager
// based on eu cck
/*
cck1 values
------------------
cm	    Indicate if a choice has already been made (true) or not (false - default)
        i.e. the banner is displayed (cm = choice made)
all1st	Indicate if all 1st party cookies are accepted (true) or only technical /
        required 1st party cookies (false - default)
closed	Cookies have been accepted and banner is closed (true) or banner is still
        visible (false - default) regardless of a choice made or not


Events
------------------
The following window events will be emitted by the CCK:
cck_banner_displayed	  Is emitted when the CCK banner is displayed
cck_all_accepted	      Is emitted when ALL cookies are accepted (Accept all cookies button)
cck_technical_accepted	Is emitted when ONLY technical cookies are accepted (Accept only essential cookies)
cck_banner_hidden	      Is emitted when the CCK banner is closed (Clicking close on the confirmation banner)
*/

/* globals $wt */
import app_data from '../../globali/get-app-data';

/* eslint-disable no-undef */
const set_analytics = () => {

    const analytics_id = 'G-QQKQJ9GBWP',
      purchase_data_element = document.getElementById('ga-purchase-data'); // deinito in landing-acquisti

    let purchase_obj = null;
    if(purchase_data_element) {
      purchase_obj = JSON.parse(purchase_data_element.dataset.d);
    }

    let script = document.createElement('script');

    script.onload = function() {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag('js', new Date());
      gtag('config', analytics_id);

      if(purchase_obj) {
        gtag('event', 'purchase', purchase_obj);
      }
    };


    script.src = `https://www.googletagmanager.com/gtag/js?id=${analytics_id}`;
    document.head.appendChild(script);

    if(app_data.dev || app_data.superAdmin) {
      /* eslint-disable no-console */
      console.log('Google Analytics ON');
      console.groupCollapsed('Impostazioni analytics');
      console.log(`analytics_id: ${analytics_id}`);
      if(purchase_obj) {
        console.log('purchase:');
        console.log(purchase_obj);
      }
      console.groupEnd();
      /* eslint-enable no-console */
    }

  },

  set_facebook_pixel_code = () => {

    const facebook_id = '2587358301511857';

    // !function(f,b,e,v,n,t,s)
    // {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    // n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    // if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    // n.queue=[];t=b.createElement(e);t.async=!0;
    // t.src=v;s=b.getElementsByTagName(e)[0];
    // s.parentNode.insertBefore(t,s)}(window, document,'script',
    // 'https://connect.facebook.net/en_US/fbevents.js');
    // fbq('init', '2587358301511857');
    // fbq('track', 'PageView');

    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ?
          n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', undefined, undefined, undefined);

    fbq('init', facebook_id);
    fbq('track', 'PageView');

    if(app_data.dev || app_data.superAdmin) {
      /* eslint-disable no-console */
      console.log('facebook pixel ON');
      /* eslint-enable no-console */
    }

  };
  /* eslint-enable no-undef */


export default function () {

  let allow_non_essential_cookies = false;

  const set_tracking_funcs = () => {
    let cck1 = JSON.parse($wt.cookie.get('cck1'));
    allow_non_essential_cookies = cck1.cm && cck1.all1st;

    if(allow_non_essential_cookies) {
      set_analytics();
      set_facebook_pixel_code();

    } else if(app_data.dev || app_data.superAdmin) {
      console.log('tracking cookies OFF'); // eslint-disable-line
    }
  };

  window.addEventListener('wtReady', function () {
    if($wt.cookie.exists('cck1')) {
      set_tracking_funcs();
    }
  });

  window.addEventListener('cck_all_accepted', () => {
    set_tracking_funcs();
  }, false);
}
